import { render } from "./Tokens.vue?vue&type=template&id=1a49d3d8&ts=true"
import script from "./Tokens.vue?vue&type=script&lang=ts"
export * from "./Tokens.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__